import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';

interface Step {
  label: string;
  sublabel: string;
  state: 'done' | 'current' | 'pending';
}

const STEPS: Step[] = [
  { label: 'Catálogo', sublabel: 'Buscar y seleccionar productos', state: 'done' },
  { label: 'Bolsa', sublabel: 'Revisar y confirmar selección', state: 'done' },
  { label: 'Cotización', sublabel: 'Ajustar precios y enviar', state: 'current' },
];

function StepDot({ state }: { state: Step['state'] }) {
  if (state === 'done') {
    return (
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: '#A3489D',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <CheckIcon sx={{ color: '#FFFFFF', fontSize: 20 }} />
      </Box>
    );
  }
  if (state === 'current') {
    return (
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '2px solid #A3489D',
          background: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Box sx={{ width: 10, height: 10, borderRadius: '50%', background: '#A3489D' }} />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        border: '2px solid #DCDCE3',
        background: '#FFFFFF',
        flexShrink: 0,
      }}
    />
  );
}

interface WorkflowCardProps {
  onBolsaClick?: () => void;
  horizontal?: boolean;
}

export function WorkflowCard({ onBolsaClick, horizontal }: WorkflowCardProps) {
  if (horizontal) {
    return (
      <Box
        data-testid="workflow-steps-horizontal"
        sx={{ display: 'flex', alignItems: 'center', gap: 0 }}
      >
        {STEPS.map((step, idx) => (
          <Box key={step.label} sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.6,
                borderRadius: '24px',
                background: step.state === 'current' ? '#F8F1F8' : 'transparent',
              }}
            >
              <StepDot state={step.state} />
              <Box>
                <Typography
                  sx={{
                    fontSize: 15,
                    fontWeight: step.state === 'current' ? 700 : 600,
                    color: step.state === 'current' ? '#A3489D' : step.state === 'done' ? '#2F2F39' : '#8A8F99',
                    lineHeight: 1.2,
                  }}
                >
                  {step.label}
                </Typography>
                <Typography sx={{ fontSize: 12, color: '#8A8F99', lineHeight: 1.2 }}>
                  {step.sublabel}
                </Typography>
              </Box>
            </Box>
            {idx < STEPS.length - 1 && (
              <Box sx={{ width: 24, height: 2, background: '#D9C6D8', mx: 0.5, borderRadius: 1 }} />
            )}
          </Box>
        ))}
      </Box>
    );
  }

  // Modo vertical original (panel lateral)
  return (
    <Box
      data-testid="workflow-card"
      sx={{
        background: '#FFFFFF',
        border: '1px solid #E6E6EB',
        borderRadius: '16px',
        boxShadow: '0 4px 14px rgba(30,30,60,0.08)',
        p: 2.5,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 17, color: '#231F2B', mb: 2 }}>
        Pasos de cotización
      </Typography>

      {STEPS.map((step, idx) => (
        <Box key={step.label}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1.2,
              borderRadius: '10px',
              background: step.state === 'current' ? '#F8F1F8' : 'transparent',
            }}
          >
            <StepDot state={step.state} />
            <Box>
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: step.state === 'current' ? 700 : 600,
                  color: step.state === 'current' ? '#A3489D' : step.state === 'done' ? '#2F2F39' : '#8A8F99',
                }}
              >
                {step.label}
              </Typography>
              <Typography sx={{ fontSize: 14, color: '#8A8F99' }}>{step.sublabel}</Typography>
            </Box>
          </Box>
          {idx < STEPS.length - 1 && (
            <Box sx={{ ml: '22px', width: 4, height: 20, background: '#D9C6D8', borderRadius: 2, my: 0.3 }} />
          )}
        </Box>
      ))}
    </Box>
  );
}
